
<div class="page-header-container">
    <div class="page-title">
        {{'specialOffers.title' | translate}}
    </div>
</div>

<div *ngIf="hasSpecialOffer || hasRequestedSpecialOffers" class="header-buttons-box">
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'specialOffers.filter' | translate}}
    </button>
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'specialOffers.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>
</div>

<div *ngIf="hasSpecialOffer" class="mb-4">
    <div class="page-subtitle text-secondary mb-3">
        {{'specialOffers.newOffer' | translate}}
    </div>
    <special-offer-card-view 
        [props]="props"
        [specialOffers]="specialOffers">  
    </special-offer-card-view>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasSpecialOffer && !hasRequestedSpecialOffers">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()">
    </no-records-placeholder>
</div>

<div *ngIf="requestedSpecialOffers && requestedSpecialOffers.length">
    <div class="page-subtitle text-secondary mb-4">
        {{'specialOffers.requestedOffer' | translate}}
    </div>
    <special-offer-card-view 
        *ngIf="hasRequestedSpecialOffers"
        [props]="props"
        [specialOffers]="requestedSpecialOffers">  
    </special-offer-card-view>
</div>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>



